import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'iaud-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  showPassword: boolean = false;
  loggingIn: boolean = false;
  keep: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    // private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      keep: [true],
    });
  }

  login(): void {
    // this.authService.login({
    //   username: this.loginForm.get('username').value,
    //   password: this.loginForm.get('password').value,
    // }).subscribe(res => {
    //   debugger
    // })
  }

  removeLoginError(): void {
    const usernameField = this.loginForm.get('username');

    if (usernameField.value !== '') {
      usernameField.setErrors(null);
    }
  }

  get username() {
    return this.loginForm.get('username');
  }

  get password() {
    return this.loginForm.get('password');
  }
}
